"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoilMoistureArea = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const typeName = 'SoilMoistureArea';
class SoilMoistureArea extends datamodel_core_1.Area {
    constructor(ob) {
        var _a, _b, _c;
        super({ ...ob, type: typeName });
        this.name = (_a = ob.name) !== null && _a !== void 0 ? _a : this.id;
        this.soilType = (_b = ob.soilType) !== null && _b !== void 0 ? _b : null;
        this.soilRisk = (_c = ob.soilRisk) !== null && _c !== void 0 ? _c : null;
        this.soilFieldCapacity = ob.soilFieldCapacity;
        this.soilStressPoint = ob.soilStressPoint;
        this.bands = ob.bands;
    }
    getUserAttributes() {
        return {
            name: {
                type: 'String',
                editable: true,
                default: false,
                label: 'Name',
                required: true,
            },
            soilType: {
                type: 'String',
                editable: true,
                label: 'Soil Type',
                name: 'Soil Type',
                // required: true,
            },
            soilRisk: {
                type: 'String',
                editable: true,
                label: 'Soil Risk',
                name: 'Soil Risk',
                // required: true,
            },
            soilFieldCapacity: {
                type: 'String',
                editable: true,
                label: 'Soil Field Capacity (%)',
                required: false,
            },
            soilStressPoint: {
                type: 'String',
                editable: true,
                label: 'Soil Stress Point (%)',
                required: false,
            },
        };
    }
}
exports.SoilMoistureArea = SoilMoistureArea;
